import React from "react";
import { Button, Icon, Label } from "semantic-ui-react";

type IconTabProps = {
  iconName: string;
  label: string;
  isActive: boolean;
  onClick: () => void;
  badgeCount?: number;
};

const PRIMARY_COLOR = "var(--primary-theme-color)";
const INACTIVE_COLOR = "rgba(179, 179, 179, 1)";

const IMAGES = {
  profile: "/static/images/chat/profile-panel-icon.png",
  note: "/static/images/chat/profile-panel-note-icon.png",
  phv: "/static/images/chat/profile-panel-phv-icon.png",
  calendar: "/static/images/chat/profile-panel-calendar-icon.png",
  profileActive: "/static/images/chat/profile-panel-active-icon.png",
  noteActive: "/static/images/chat/profile-panel-note-active-icon.png",
  phvActive: "/static/images/chat/profile-panel-phv-active-icon.png",
  calendarActive: "/static/images/chat/profile-panel-calendar-active-icon.png",
};

const iconMap: { [key: string]: string } = {
  user: "profile",
  "file alternate": "phv",
  calendar: "calendar",
  "sticky note": "note",
  shop: "cart",
  "shopping cart": "cart",
};

const getIconColor = (isActive: boolean) => (isActive ? "#f382a0" : INACTIVE_COLOR);

const IconTab: React.FC<IconTabProps> = (props) => {
  const iconKey = iconMap[props.iconName] + (props.isActive ? "Active" : "");
  const iconImage = (IMAGES as Record<string, string>)[iconKey];

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        cursor: "pointer",
      }}
      onClick={props.onClick}
    >
      <div style={{ position: "relative" }}>
        <Button
          icon
          // basic
          style={{
            width: "35px",
            height: "35px",
            padding: 0,
            borderColor: getIconColor(props.isActive),
            backgroundColor: "white",
            // border: "solid 1px red"
          }}
        >
          {iconImage ? (
            <img
              src={iconImage}
              alt={props.label}
              style={{ width: "25px", height: "25px", margin: 0, padding: 0 }}
            />
          ) : (
            <Icon
              name={props.iconName as any}
              style={{ color: getIconColor(props.isActive), fontSize: "24px", margin: 0 }}
            />
          )}
        </Button>
        {props.badgeCount !== undefined && props.badgeCount > 0 && !props.isActive && (
          <Label
            // circular
            // color="pink"
            size="mini"
            style={{
              position: "absolute",
              top: "-8px",
              // right: "-8px",
              left: "-8px",
              // background: PRIMARY_COLOR,
              background: "none",
              fontSize: "9px",
              padding: "4px",
              minWidth: "16px",
              minHeight: "16px",
            }}
          >
            {props.badgeCount}
          </Label>
        )}
      </div>
      <div
        style={{
          fontWeight: 600,
          fontSize: "11px",
          color: getIconColor(props.isActive),
          // marginTop: "5px",
        }}
      >
        {props.label}
      </div>
    </div>
  );
};

export default IconTab;
